import React from 'react';

import { withRouter } from '../../utility/hoc/with-router';
import { Context, GoogleAnalyticsConsumer } from './context';

export type Props = {
    onLocationChange?: (locationPath: string, prevLocationPath?: string) => void;
};
export type InjectedProps = Pick<Context, 'trackSceneView'>;

export default function <BaseProps extends Props>(BaseComponent: React.ComponentType<BaseProps>) {
    if (BaseComponent == null) {
        throw new Error('Component not passed to withGoogleAnalytics');
    }

    type NewProps = {
        location: { pathname: string };
    };

    // HOC with injected props
    class NewComponent extends React.Component<BaseProps & NewProps & InjectedProps> {
        // Enhance component name for debugging
        static displayName = `WithTrackedSceneView(${BaseComponent.name})`;

        componentDidMount() {
            const {
                location: { pathname },
                onLocationChange,
                trackSceneView,
            } = this.props;
            trackSceneView(pathname);
            onLocationChange?.(pathname);
        }

        componentDidUpdate(prevProps: NewProps) {
            const { pathname: prevPathname } = prevProps.location;
            const {
                location: { pathname },
                onLocationChange,
                trackSceneView,
            } = this.props;

            if (prevPathname !== pathname) {
                trackSceneView(pathname);
                onLocationChange?.(pathname, prevPathname);
            }
        }

        render() {
            return <BaseComponent {...this.props} />;
        }
    }

    return withRouter((props: BaseProps & NewProps) => (
        <GoogleAnalyticsConsumer>
            {(ga) => <NewComponent {...props} trackSceneView={ga.trackSceneView} />}
        </GoogleAnalyticsConsumer>
    ));
}
